import { Component } from "react";
import axios from "./api.service";
export default class ActivityService extends Component {
	static async createActivity(activity) {
		return axios.post(`/activity/create`, activity);
	}

	static async createAudioActivity(activity) {
		let form = new FormData();

		for (var i = 0; i < activity.alternatives.length; i++)
			form.append("alternatives[]", activity.alternatives[i]);
		form.append("audio", activity.audio);
		form.append("correct", activity.correct);
		form.append("title", activity.title);
		form.append("type", activity.type);
		form.append("unity", activity.unity);

		return axios.post(`/activity/create`, form, {
			header: { "Content-Type": "multipart/form-data" },
		});
	}

	static async listAllActivities() {
		return axios
			.get(`/activity/getAll`)
			.then((res) => {
				return res.data;
			})
			.catch((err) => {
				return [];
			});
	}

	static async listOneActivity(id) {
		return axios
			.get(`/activity/getOne/${id}`)
			.then((res) => {
				return res.data.activities.activities;
			})
			.catch((err) => console.error);
	}

	static async updateActivity(id, activity) {
		return axios.put(`/activity/edit/${id}`, activity);
	}

	static async deleteActivity(id) {
		return axios.delete(`/activity/delete/${id}`);
	}
}
